<template>

    <transition name="modal-fade" v-if="isVisible">
        <div class="modal-overlay">
            <div class="modal-content">
                <div  class="custom-popup">
                    <div class="popup-content">
                        
                        <div class="popup-title" v-html="title"></div>
                        <div><img src="../../assets/img/UNDERLINE.png" alt="icon" class="popup-divider" /></div>
                        
                        <div class="popup-message-container">
                            <div class="popup-message" v-html="content"></div>
                            <div class="popup-actions">
                                
                                <div class="confirm-button" @click="handleConfirm">{{ confirmText }}</div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            visible: Boolean,            
            title: String,
            content: String,           
            confirmText: String,
            confirmAction: Function,
            autoClose: {
                type: Boolean, default: false
            }
        },

        data() {
            return {
                isVisible: this.visible, // Local visibility state
                autoCloseTime: 2000, 
            };
        },
        watch: {
            visible(newVal) {
                this.isVisible = newVal; // Sync local state with prop changes

                if (newVal && this.autoClose) {
                    this.startAutoCloseTimer();
                }
            },
        },

        methods: {
           
            handleConfirm() {
                if (this.confirmAction) {
                    this.confirmAction();
                }
                this.isVisible = false;
                this.$emit('cancel');
            },

            startAutoCloseTimer() {
                setTimeout(() => {                   
                    this.handleConfirm(); // Emit cancel when auto-closed
                    this.isVisible = false;
                }, this.autoCloseTime);
            },

        },
    };
</script>

<style scoped>

    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #00000088;
        z-index: 999;
    }

    .modal-content {
        text-align: center;
        height:fit-content;    
        width: fit-content;
        max-width: 480px;
        min-width: 320px;
        margin: auto 16px;
        overflow: hidden;
    }

    .popup-content {
        text-align: center;
       
        background-color:white;
        border-radius: 8px;
    }

    .icon {
        margin-bottom: 1rem;
        font-size: 1rem;
    }

    .popup-title {
        font-size: 1.2rem;
        font-weight: bold;
        margin: 0;
        color:#198754;
        padding-top: 16px;
    }

    .popup-message {
        font-size: .8rem;
        margin: 0.5rem 0 1rem;
        color:black;
        font-weight: bold;
    }

    .popup-buttons {
        display: flex;
        justify-content: center;
        gap: 1rem;
    }

    
    .popup-actions{display:flex; gap: 16px; justify-content:center;}

    /* Basic button styles */
        .popup-actions div {           
            border: none;
            min-width: 98px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
        }

    /* Cancel Button */
    .cancel-button {
        background-color: #e0e0e0; /* light gray */
        color: #555; /* dark gray */
        padding: 8px 24px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
        margin-right: 8px;
    }

        .cancel-button:hover {
            background-color: #cccccc;
        }

    /* Confirm Button (Success) */
    .confirm-button {
        background-color: #6655e3; /* green */
        color: white;
        padding: 8px 24px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

        .confirm-button:hover {
            background-color: rgb(52, 31, 212);
        }

    /* Confirm Button (Error) */
    .error-button {
        background-color: #f34546; /* red */
        color: white;
        padding: 8px 24px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

        .error-button:hover {
            background-color: #e53935;
        }

    .popup-divider{width: 100%; max-width: 170px; margin: auto;}
    .popup-message-container{background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)); padding: 16px; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;}
</style>
